export const chartPredictionSeries = (data, field) => (
  field === 'daily_prediction'
    ? (data?.prediction ?? data?.daily_prediction)
    : data?.[field]
);

export const finiteChartNumber = (value) => {
  if (value === null || value === undefined || String(value).trim() === '') {
    return undefined;
  }
  const number = Number(value);
  return Number.isFinite(number) ? number : undefined;
};
